const API_PRODUCT_URL = `${window.location.protocol}//${window.location.host}/api/nh/product`;
import { IfcFavoritesRequest } from "Interfaces/ifcFavoritesRequest";
import { IfcFavoriteProjectsRequest } from "Interfaces/ifcFavoritesRequest";
import { IfcProduct } from "Interfaces/ifcProduct";
import { IfcWorkbenchProjects } from "Interfaces/ifcWorkbenchProjects";

export default class FavoritesService {
    static _initialized: boolean = false;
	
	favoriteProductsRequest: IfcFavoritesRequest = {
		stockNumbers: []				
	  };
	  favoriteProjectsRequest: IfcFavoriteProjectsRequest = {
		projectSlugs: []				
	  };

	// Insure that there's a single instance of FavoritesService shared by all components
	static _instance: FavoritesService;
	static products: IfcProduct[] = [];
	static projects: IfcWorkbenchProjects[] = [];
	static stockNumbers: string[] = [];
	static projectsBaseUrl: string;
	

	static getInstance(): FavoritesService {
		return FavoritesService._instance || new FavoritesService();
	}

	get initialized() {
		return this.initialized;
	}	
	
	constructor() {
		if (!FavoritesService._instance) {
			FavoritesService._instance = this;
		}
		return FavoritesService._instance;
	}	

	static fetchApiProductData(request?:IfcFavoritesRequest) {
		return fetch(API_PRODUCT_URL, {
			method: "POST",
			body: JSON.stringify(request),
			headers: {
				"Content-type": "application/json"
			}
		}).then((response) => {
			return response.json().then((data) => {					
				let favoriteProducts = data.data.products as IfcProduct[];	
				this.products = favoriteProducts;						
				this.init(favoriteProducts, null)		
				return data;
			}).catch((err) => {
				console.log(err);
			})
		});
	}	

	static init(products: IfcProduct[], projects: IfcWorkbenchProjects[]) {
		if(products != null)
		{
		  (Object).assign(this.products, products);	
		}
		if(projects != null)
		{
		  (Object).assign(this.projects, projects);	
		}
		this._initialized = true;
	}

	/*static inFavoriteProducts(stockNumber: string): boolean {
		for (let nextProduct of this.products) {
			if (nextProduct.stockNumber === stockNumber) {
				return true;
			}
		}
		return false;
	}
	static inFavoriteProjects(projectId: string): boolean {
		for (let nextProject of this.projects) {
			if (nextProject.UrlName === projectId) {
				return true;
			}
		}
		return false;
	} */
}


